import { useTranslation } from 'react-i18next';
import { useApp } from '@/context/AppContext';
import styles from '@/styles/components/ProgressIndicator.module.css';

export default function ProgressIndicator() {
  const { t } = useTranslation();
  const { state } = useApp();
  const steps = t('progressSteps', { returnObjects: true }) as string[];

  return (
    <div className={styles.progressContainer}>
      {steps.map((step, index) => (
        <div
          key={step}
          className={`${styles.progressStep} ${index + 1 <= state.currentStep ? styles.active : ''}`}
        >
          <div className={styles.stepIndicator}>{index + 1}</div>
          <span>{step}</span>
        </div>
      ))}
    </div>
  );
}